import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

export default class BannerPrincipal {
    constructor() {

        this.section = document.querySelector('.component-banner_principal');
        
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.section.querySelector('.slider-button-prev');
        this.navigationNext = this.section.querySelector('.slider-button-next');
        this.pagination = this.section.querySelector('.swiper-pagination-nav');
        
        this.ready();
    }

    ready() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            pagination: {
                el: this.pagination,
                clickable: true
            },
        });
    }

}

if (document.querySelector('.component-banner_principal')) {
    new BannerPrincipal();
}